import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ControlName } from '../../enums/control-name.enum';
import { AddressQuestion } from '../../interfaces/meta/questions/address';

@Component({
    selector: 'smvd-shared-question-address',
    templateUrl: 'question-address.component.html',
})
export class QuestionAddressComponent implements OnInit {
    @Input() question: AddressQuestion;
    @Input() group: UntypedFormGroup;

    public controlName = ControlName;
    public fields = {};

    public ngOnInit(): void {
        this.question.fields?.forEach((field) => (this.fields[field.type] = field.visible));
    }
}
